import axios from 'axios';
import { API_URL } from '../config';

const getToken = () => localStorage.getItem('token');
const authHeaders = () => ({
  headers: { Authorization: `Bearer ${getToken()}` }
});

export const aiControlsService = {
  getUserDefaultRules: async () =>
    (await axios.get(`${API_URL}/ai-rules/defaults`, authHeaders())).data,
  updateUserDefaultRules: async (rules) =>
    (await axios.put(`${API_URL}/ai-rules/defaults`, { rules }, authHeaders())).data,
  getAllRules: async () => 
    (await axios.get(`${API_URL}/ai-rules`, authHeaders())).data,
  getRulesByUserId: async (userId) =>
    (await axios.get(`${API_URL}/ai-rules/user/${userId}`, authHeaders())).data,
  getRuleById: async (ruleId) =>
    (await axios.get(`${API_URL}/ai-rules/${ruleId}`, authHeaders())).data,
  createRule: async (ruleData) =>
    (await axios.post(`${API_URL}/ai-rules`, ruleData, authHeaders())).data,
  updateRule: async (ruleId, ruleData) =>
    (await axios.put(`${API_URL}/ai-rules/${ruleId}`, ruleData, authHeaders())).data,
  deleteRule: async (ruleId) =>
    (await axios.delete(`${API_URL}/ai-rules/${ruleId}`, authHeaders())).data,
  toggleRuleEnabled: async (ruleId, isEnabled) =>
    (await axios.put(`${API_URL}/ai-rules/${ruleId}/toggle`, { is_enabled: isEnabled }, authHeaders())).data
};
